import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import { vantPlugins } from './plugins/vant'
import VConsole from 'vconsole'
import {
  Button,
  Stepper,
  Step,
  Steps,
  Field,
  CellGroup,
  PickerGroup,
  Popup,
  DatePicker,
  Picker,
  TimePicker,
  Toast,
  Dialog,
  List,
  Icon,
  ActionSheet,
  RadioGroup,
  Radio,
  Cell,
  Col,
  Row,
  Tab,
  Tabs,
  Image as VanImage
} from 'vant'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

if (import.meta.env.MODE !== 'prod') {
  new VConsole()
}

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vantPlugins)
app.use(Button)
app.use(Stepper)
app.use(Step)
app.use(Steps)
app.use(Field)
app.use(PickerGroup)
app.use(CellGroup)
app.use(Popup)
app.use(DatePicker)
app.use(Picker)
app.use(TimePicker)
app.use(Toast)
app.use(Dialog)
app.use(List)
app.use(Icon)
app.use(ActionSheet)
app.use(RadioGroup)
app.use(Radio)
app.use(Cell)
app.use(CellGroup)
app.use(Col)
app.use(Row)
app.use(Tab)
app.use(Tabs)
app.use(VanImage)
app.mount('#app')
